<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        title="物料信息表"
        class="customer-edit"
        width="1000px"
        top="5vh"
        @close="onDialogClose">
      <el-button
          :loading="submitLoading"
          style="margin-bottom: 3%"
          type="primary"
          @click="handleSubmit">
        保存
      </el-button>
      <vm-table
          ref="vmTable"
          method="get"
          :filter.sync="filter"
          module="basic"
          url="baseMaterials/materialId"
          @select="selectTest"
          @select-all="selectAll">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="物料编号">
              <el-input v-model.trim="filter.no" clearable/>
            </vm-search>
            <vm-search label="物料描述">
              <el-input v-model.trim="filter.name" clearable/>
            </vm-search>
            <vm-search label="物料组">
              <el-input v-model.trim="filter.materialGroupNO" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column prop="no" align="center" width="120" label="物料编号"/>
        <el-table-column prop="name" align="center" label="物料描述"/>
        <el-table-column prop="materialGroupNO" width="100" align="center" label="物料组"/>
        <el-table-column prop="productGroupNO" width="100" align="center" label="产品组"/>
        <el-table-column prop="purchaseGroupNO" width="100" align="center" label="采购组"/>
      </vm-table>
    </el-dialog>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import constant from "@/util/constant";
  import VmSearch from "@/components/VmSearch";

  export default {
    name:"ReplicationTable",
    components: {VmSearch, VmTable},
    data() {
      return {
        inspectionType: constant.inspectionType,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        newPkids: [],
        materials: {
          id: 0,
        },
        filter: {
          no: "",
          name: "",
          materialGroupNO: "",
          materialId: "",
        },
        ruleValidate: {
        },
        idList: [],
      };
    },
    methods: {
      open(row) {
        this.materials.id = row.id;
        console.log(this.materials.id);
        this.filter.materialId = row.id;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      handleSubmit() {
        this.newPkids=[];
        console.log(this.idList);
        for(let item of this.idList) {
          this.newPkids.push(item.id);
        }
        let prams = {
          sapMaterialId:this.materials.id,
          ids: this.newPkids,
        };
        console.log(prams);
        this.$http
          .post("basic", "baseMaterials/sapMaterialId",prams)
          .then(() => {
            this.submitLoading = false;
            //this.dialogVisible = false;
            this.$message.success("保存成功");
            this.idList = [];
            this.newPkids = [];
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      onDialogClose() {
        this.submitLoading = false;
        this.contentLoading = false;
        this.idList = [];
        this.newPkids = [];
        this.materials.id = 0;
        this.filter.materialId = 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
